export function track() {}

export default { track };
